var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUserCircleSolid = function SvgUserCircleSolid(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 9,
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 21a8.963 8.963 0 0 0 3.937-.904A9.15 9.15 0 0 1 12 21Zm5.277-1.709a4.34 4.34 0 0 0 .349-.291v-1.189A4.001 4.001 0 0 0 14 15.5h-4a4 4 0 0 0-3.626 2.311V19c.092.087.208.185.347.29a9 9 0 1 1 10.557.002Zm-9.21.806A9.151 9.151 0 0 0 12 21a8.965 8.965 0 0 1-3.934-.903ZM12 13.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7Z",
    fill: "currentColor"
  })));
};
export default SvgUserCircleSolid;